import { defineMessages } from "react-intl";

export const messages = defineMessages({
	userList: {
		id: "user_list.title",
		defaultMessage: "Felhasználó lista"
	},
	name: {
		id: "user_list.name",
		defaultMessage: "Név"
	},
	email: {
		id: "user_list.email",
		defaultMessage: "Email cím"
	},
	phoneNumber: {
		id: "user_list.phone_number",
		defaultMessage: "Telefonszám"
	},
	state: {
		id: "user_list.state",
		defaultMessage: "Státusz"
	},
	active: {
		id: "user_list.active",
		defaultMessage: "Aktív"
	},
	inactive: {
		id: "user_list.inactive",
		defaultMessage: "Inaktív"
	},
	activateSuccess: {
		id: "user_list.activate_success",
		defaultMessage: "Felhasználó aktiválva"
	},
	deactivateSuccess: {
		id: "user_list.deactivate_success",
		defaultMessage: "Felhasználó deaktiválva"
	}
});
